<template>
  <div>
    <headTop />
    <LoopImg/>
    <div class="container">
      <div class="main">
        <div class="breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }" class="home">{{ $t('navbar.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('navbar.exhibition') }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="title">
          <span>{{ $t('navbar.exhibition') }}</span>
        </div>
        <div class="content">
          <Screen/>
        </div>
      </div>
    </div>
    <footBottom />
  </div>
</template>

<script>
import headTop from '../../common/head.vue';
import footBottom from '../../common/footBottom.vue';
import Screen from './components/screen.vue';
import LoopImg from './components/loopImg.vue';

export default {
  components: {
    headTop,
    footBottom,
    Screen,
    LoopImg
 
  },
  data() {
    return {};
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  background: #f6f6f7;
  .main {
    padding-top: 23px;
    box-sizing: border-box;
    margin: 0 auto;
    // margin-top: 100px;
    // border: 1px solid blue;
    width: 1270px;
    .breadcrumb {
      a {
        color: #006fb8;
      }
    }
    .title {
      margin-top: 46px;
      span {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
</style>
